var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPersonFill = function SvgIcPersonFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.294 8.092A5.274 5.274 0 0 1 12 13.384a5.275 5.275 0 0 1-5.294-5.292A5.274 5.274 0 0 1 12 2.8a5.273 5.273 0 0 1 5.294 5.29M12 21.8c-4.338 0-8-.704-8-3.424 0-2.721 3.685-3.401 8-3.401 4.339 0 8 .705 8 3.425s-3.685 3.4-8 3.4"
  })));
};
export default SvgIcPersonFill;